import { render, staticRenderFns } from "./sidenav.vue?vue&type=template&id=6d527aa3&scoped=true"
import script from "./sidenav.vue?vue&type=script&lang=js"
export * from "./sidenav.vue?vue&type=script&lang=js"
import style0 from "./sidenav.vue?vue&type=style&index=0&id=6d527aa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d527aa3",
  null
  
)

/* custom blocks */
import block0 from "./sidenav.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports